import axios from 'axios';
import { IPatientDto } from 'entities/Patient/Patient.models';

const basePath = 'patients/by-event';

export const patientTransport = {
  getPatientModel: (eventId: number): Promise<IPatientDto> => axios.get(`${basePath}/${eventId}`),
};
